import { orgsKeys } from "src/data/organizations/queries/organizationQueryCache"

export const homeKeys = orgsKeys
